import styled from 'styled-components'

export const StyledPopoverContainer = styled.div`
  padding: 15px 20px;
`
